// Shared formatting helpers for the Staffing & Development Tracker module.
import { c } from '../../theme';

export function fmtNumber(n) {
  return Number(n || 0).toLocaleString('en-US');
}

export function fmtPercent(n) {
  return `${Number(n || 0).toLocaleString('en-US', { maximumFractionDigits: 1 })}%`;
}

export function fmtDate(d) {
  if (!d) return '—';
  const s = String(d).slice(0, 10);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (m) return `${+m[2]}/${+m[3]}/${m[1]}`;
  return s;
}

// Driver/Mechanic/Operations/Admin — a consistent color per category across
// every Staffing Tracker table. Four real semantic categories theme.js has
// no tokens for, so each keeps its own hue; Admin leans on the neutral ramp
// since it reads as "no category" as much as a category of its own.
// `border` is a brighter step of the same hue -- used as a row accent on
// tables that mix categories (Vacancies, New Hires, Roster); Admin's border
// stays a plain gray rather than its own text color, which would read as a
// dark/urgent accent instead of "no category".
const CATEGORY_COLORS = {
  Driver:     { bg: c.infoTint, color: c.info,      border: '#60A5FA' },
  Mechanic:   { bg: '#FFF7ED',  color: '#C2410C',   border: '#FB923C' },
  Operations: { bg: '#F5F3FF',  color: '#6D28D9',   border: '#8B5CF6' },
  Admin:      { bg: c.canvas,   color: c.textStrong, border: c.borderStrong },
};
export function categoryColor(category) {
  return CATEGORY_COLORS[category] || { bg: c.canvas, color: c.textMuted, border: c.border };
}

const STATUS_COLORS = {
  Open:  { bg: c.successTint, color: c.successText },
  Offer: { bg: c.warningTint, color: c.warningText },
};
export function statusColor(status) {
  return STATUS_COLORS[status] || { bg: c.canvas, color: c.textMuted };
}
